import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ListaProdutosLayer from "../components/ListaProdutosLayer";
import { useTranslation } from "../i18n/I18nContext";

const ProdutosPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("produto.breadcrumb.list")} />
      <ListaProdutosLayer />
    </MasterLayout>
  );
};

export default ProdutosPage;
